import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

const CompoundStartPrice = ({
  type,
  startPrice,
  currency
}: StartPriceProps) => {
  const { t } = useTranslation(['search', 'common']);
  return (
    <StartPriceContainer>
      <div className="price-text">
        {type === 'developer'
          ? t('developer_start_price', { ns: 'common' })
          : t('resale_start_price', { ns: 'common' })}
      </div>

      <div className="price-container">
        {startPrice ? (
          <>
            <span className="currency">{currency ?? t('egp')}</span>
            <span className="price">{startPrice?.toLocaleString()}</span>
          </>
        ) : (
          <span>{t('no_units', { ns: 'common' })}</span>
        )}
      </div>
    </StartPriceContainer>
  );
};

interface StartPriceProps {
  type: 'developer' | 'resale';
  startPrice: number | null;
  currency: string;
}

interface CompoundCardPaymentPlan {
  paymentPlan: {
    downPayment: number | string;
    developerPrice: number;
    resalePrice: number;
    currency: string;
  };
}
const CardPaymentPlan = ({ paymentPlan }: CompoundCardPaymentPlan) => {
  return (
    <Container>
      <CompoundStartPrice
        type="developer"
        startPrice={paymentPlan?.developerPrice}
        currency={paymentPlan?.currency}
      />
      <CompoundStartPrice
        type="resale"
        startPrice={paymentPlan?.resalePrice}
        currency={paymentPlan?.currency}
      />
    </Container>
  );
};

const StartPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .price-text {
    color: #5b6573;
    font-family: materialRegular;
    font-size: 12px;
  }

  .price-container {
    display: flex;
    align-items: center;
    gap: 4px;

    .currency {
      color: #1a2028;
      font-family: materialRegular;
      font-size: 12px;
    }

    .price {
      color: #1a2028;
      font-size: 17px;
      font-family: materialBold;
    }
  }

  span {
    color: #1a2028;
    font-family: materialRegular;
    font-size: 12px;
  }

  @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
    width: 100%;
    .price-text {
      color: #5b6573;
      font-family: materialRegular;
      font-size: 11px;
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;

  gap: 48px;
  width: 100%;

  .highlight {
    color: #ff5e00;
    font-family: materialSemiBold;
  }
  @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
    gap: 8px;
  }
`;

export default CardPaymentPlan;
